(function () {
  var COLLAPSED_HEIGHT_DESKTOP = 775;
  var COLLAPSED_HEIGHT_MOBILE = 625;
  var SCROLL_EXTRA_OFFSET = 16;

  function getCollapsedMaxHeight() {
    return window.matchMedia('(max-width: 749px)').matches
      ? COLLAPSED_HEIGHT_MOBILE
      : COLLAPSED_HEIGHT_DESKTOP;
  }

  function getStickyHeaderOffset() {
    var total = 0;
    var stickyWrap = document.getElementById('StickyHeaderWrap');

    if (stickyWrap && stickyWrap.offsetHeight) {
      total += stickyWrap.offsetHeight;
    } else {
      var siteHeader = document.getElementById('SiteHeader');
      if (siteHeader) {
        total += siteHeader.offsetHeight;
      }
    }

    ['.toolbar', '.announcement-bar'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) {
        return;
      }

      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed' && style.position !== 'sticky') {
        return;
      }

      var rect = el.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0) {
        total += el.offsetHeight;
      }
    });

    return total + SCROLL_EXTRA_OFFSET;
  }

  function scrollToElement(element) {
    if (!element) {
      return;
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var top =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          getStickyHeaderOffset();

        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      });
    });
  }

  function wrapTables(contentEl) {
    contentEl.querySelectorAll('table').forEach(function (table) {
      if (
        table.parentElement &&
        table.parentElement.classList.contains('loanti-collection-description__table-wrap')
      ) {
        return;
      }

      var wrap = document.createElement('div');
      wrap.className = 'loanti-collection-description__table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function expandDescription(state) {
    state.container.classList.add('loanti-collection-description--expanded');
    state.toggle.setAttribute('aria-expanded', 'true');
    state.toggle.textContent = 'Zwiń opis';
  }

  function collapseDescription(state) {
    state.container.classList.remove('loanti-collection-description--expanded');
    state.toggle.setAttribute('aria-expanded', 'false');
    state.toggle.textContent = 'Czytaj całość';
  }

  function updateToggleVisibility(state) {
    var collapsedHeight = getCollapsedMaxHeight();

    state.container.classList.add('loanti-collection-description--measuring');
    var fullHeight = state.content.scrollHeight;
    state.container.classList.remove('loanti-collection-description--measuring');

    if (fullHeight <= collapsedHeight) {
      state.container.classList.add('loanti-collection-description--short');
      state.container.classList.remove('loanti-collection-description--expanded');
      state.toggle.setAttribute('aria-expanded', 'false');
      state.toggle.textContent = 'Czytaj całość';
      return;
    }

    state.container.classList.remove('loanti-collection-description--short');
  }

  function getDescriptionState(container) {
    var content = container.querySelector('.loanti-collection-description__content');
    var toggle = container.querySelector('.loanti-collection-description__toggle');

    if (!content || !toggle) {
      return null;
    }

    return {
      container: container,
      content: content,
      toggle: toggle
    };
  }

  function initTopReadMoreButtons() {
    document.querySelectorAll('[data-loanti-read-more-top]').forEach(function (btn) {
      if (btn.getAttribute('data-loanti-top-initialized') === 'true') {
        return;
      }

      btn.addEventListener('click', function (event) {
        event.preventDefault();

        var container = document.getElementById('loanti-opis-kategorii');
        scrollToElement(container);
      });

      btn.setAttribute('data-loanti-top-initialized', 'true');
    });
  }

  function initCollectionDescription(container) {
    if (!container) {
      return;
    }

    if (container.getAttribute('data-loanti-description-initialized') === 'true') {
      return;
    }

    var state = getDescriptionState(container);
    if (!state) {
      return;
    }

    wrapTables(state.content);
    updateToggleVisibility(state);

    state.toggle.addEventListener('click', function () {
      var isExpanded = container.classList.contains('loanti-collection-description--expanded');

      if (isExpanded) {
        collapseDescription(state);
        scrollToElement(container);
        return;
      }

      expandDescription(state);
    });

    var debouncedResize;
    window.addEventListener('resize', function () {
      clearTimeout(debouncedResize);
      debouncedResize = setTimeout(function () {
        var wasExpanded = container.classList.contains('loanti-collection-description--expanded');
        updateToggleVisibility(state);

        if (wasExpanded && !container.classList.contains('loanti-collection-description--short')) {
          expandDescription(state);
        }
      }, 150);
    });

    container.setAttribute('data-loanti-description-initialized', 'true');
  }

  function initAll(root) {
    root = root || document;

    if (root.id === 'loanti-opis-kategorii') {
      initCollectionDescription(root);
    } else if (root.querySelector) {
      var container = root.querySelector('#loanti-opis-kategorii');
      if (container) {
        initCollectionDescription(container);
      }
    }

    initTopReadMoreButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
